var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-generator",style:(_vm.sizeStyles)},[(_vm.isGenerating)?_c('i',{staticClass:"el-icon-loading"}):(_vm.isFailed || !_vm.qrcodeURL)?_c('i',{staticClass:"el-icon-warning-outline"}):(_vm.qrcodeURL)?_c('img',{attrs:{"src":_vm.qrcodeURL,"width":_vm.size,"height":_vm.size,"decoding":"async","alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }